import React from 'react';
import PropTypes from 'prop-types';
import './TooltipedNumber.scss';
import Tooltip from '../Tooltip/Tooltip';

export function TooltipedNumber({ number = 0, howManyDigits, ...rest }) {
  const processedNumber = number?.toFixed(howManyDigits);
  return (
    <Tooltip text={`${number}`} {...rest}>
      {processedNumber}
    </Tooltip>
  );
}
TooltipedNumber.propTypes = {
  number: PropTypes.number,
  howManyDigits: PropTypes.number,
};
TooltipedNumber.defaultProps = {
  howManyDigits: 3,
  number: 0,
};
